import { DEFAULT_CONFIG } from '../constants';
import { RestClient } from '../rest-client';
const buildGetReadTokenURL = accountId => `/api/user-image/${accountId}/header-image/read`;
export class UserPreferencesClient extends RestClient {
  async getReadMediaToken(accountId) {
    return this.getResource(buildGetReadTokenURL(accountId)).then(response => response);
  }
  async getWriteMediaToken() {
    return this.getResource('/api/user-image/header-image/write').then(response => response);
  }
  async updateUserHeaderImage(headerImageId) {
    return await this.putResource('/api/user-image/self/header-image', {
      headerImageId
    });
  }
}
export default new UserPreferencesClient({
  serviceUrl: DEFAULT_CONFIG.stargateRoot
});